<template>
    <div>
    <div class="collapsible" id="infos-intervention" :class="stateClass">

        <!-- HEADER cliquable -->
        <div id="head-intervention" @click="$emit('openCollapsible', 'infos-intervention')"
        class="w-full flex items-center justify-between px-4 py-3 rounded-lg cursor-pointer transition select-none mb-5" :class="stateClass === 'open' ? 'bg-gray-700' : 'bg-gray-200'">
            <span class="uppercase font-semibold tracking-wide " :class="stateClass === 'open' ? 'text-white' : 'text-gray-700'">
            INFORMATIONS SUR L' INTERVENTION
            </span>

            <!-- Flèche dans un rond -->
            <div
                class="w-8 h-8 rounded-full flex items-center justify-center bg-white shadow text-secondary transition">
                <i class="inline-block h-6 w-6 mask mask-arrow-right bg-secondary transition-transform duration-300"
                    :class="stateClass === 'open' ? 'rotate-90' : 'rotate-0'"></i>
            </div>
        </div>

        <!-- CONTENU : visible seulement si "open" -->
        <div class="space-y-4" id="info-intervention" v-show="stateClass === 'open'">

            <div>
                <label class="label">Déplacement</label>
                <div class="skin-select">
                    <select class="input" name="temps_deplacement" v-model="informations.temps_deplacement"
                        @change="updateInfos">
                        <option :value="null">Sélectionnez une valeur</option>
                        <option>Forfait</option>
                        <option>Forfait zone 1</option>
                        <option>Forfait zone 2</option>
                        <option>Forfait zone 3</option>
                        <option>Forfait hors zone</option>
                        <option>Forfait nuit</option>
                        <option>15min</option>
                        <option>30min</option>
                        <option>45min</option>
                        <option>1h00min</option>
                        <option>1h15min</option>
                        <option>1h30min</option>
                        <option>1h45min</option>
                        <option>2h00min</option>
                        <option>2h30min</option>
                        <option>3h00min</option>
                    </select>
                </div>
            </div>

            <div>
                <label class="label">Kilométrage (Km)</label>
                <input class="input" title="miles" type="number" min="0" step="1"
                    v-model.number="informations.kilometrage" @change="updateInfos">
            </div>
            <label class="label">Temps d'intervention</label>
            <div class="skin-select">
                <select class="input" name="temps_intervention" v-model="informations.temps_intervention"
                    @change="updateInfos('temps_intervention')">
                    <option :value="null">Sélectionnez une valeur</option>
                    <option>15min</option>
                    <option>30min</option>
                    <option>45min</option>
                    <option>1h00min</option>
                    <option>1h15min</option>
                    <option>1h30min</option>
                    <option>1h45min</option>
                    <option>2h00min</option>
                    <option>2h30min</option>
                    <option>3h00min</option>
                    <option>3h30min</option>
                    <option>4h00min</option>
                    <option>4h30min</option>
                    <option>5h00min</option>
                    <option>5h30min</option>
                    <option>6h00min</option>
                    <option>6h30min</option>
                    <option>7h00min</option>
                    <option>7h30min</option>
                    <option>8h00min</option>
                    <option>8h30min</option>
                    <option>9h00min</option>
                    <option>8h30min</option>
                    <option>9h00min</option>
                    <option>9h30min</option>
                    <option>10h00min</option>
                    <option>1 jour</option>
                    <option>2 jours</option>
                    <option>3 jours</option>
                    <option>4 jours</option>
                    <option>5 jours</option>
                    <option>Autre</option>
                    <option>Forfait</option>
                    <option v-if="informations.temps_intervention !== null">{{ informations.temps_intervention }}</option>
                </select>
            </div>

            <div>
                <label class="label">Heure d'arrivée</label>
                <input class="input" title="heureDarrive" type="time" pattern="[0-9]{2}:[0-9]{2}"
                    v-model="informations.heure_arrivee" @change="setHeureArrivee($event)">
            </div>
            <div>
                <label class="label">Heure de départ</label>
                <input class="input" title="heureDepart" type="time" pattern="[0-9]{2}:[0-9]{2}"
                    v-model="informations.heure_depart" @change="setHeureDepart($event)">
            </div>
            <div>
                <label class="label">Nombre de techniciens</label>
                <input class="input" title="numberOfTechs" type="number" min="0" v-model.number="informations.techs"
                    @change="updateInfos">
            </div>
            <div>
                <label class="label">Noms des techniciens</label>
                <input class="input" title="techNames" type="text" v-model="informations.namesTechniciens"
                    @change="updateInfos">
            </div>
            <div class="clear"></div>

            <!-- =======================
             Type d'intervention (checkbox stylées)
             ======================= -->
            <label class="label">Type d'intervention</label>
            <div class="space-y-3">

                <div>
                    <input type="checkbox" id="preventif" name="preventif" v-model="informations.preventif"
                        @change="typeUniqueCheck('preventif')" class="sr-only peer">
                    <label for="preventif" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                          peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                          flex items-center justify-between">
                        <span>PREVENTIF (visite d'entretien)</span>
                        <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                    </label>
                </div>

                <div>
                    <input type="checkbox" id="correctif" name="correctif" v-model="informations.correctif"
                        @change="typeUniqueCheck('correctif')" class="sr-only peer">
                    <label for="correctif" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                          peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                          flex items-center justify-between">
                        <span>CORRECTIF (dépannage)</span>
                        <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                    </label>
                </div>

                <div>
                    <input type="checkbox" id="from-devis" name="from-devis" v-model="informations.fromDevis"
                        @change="updateInfos" class="sr-only peer">
                    <label for="from-devis" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                          peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                          flex items-center justify-between">
                        <span>Selon devis</span>
                        <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                    </label>
                </div>

                <div>
                    <input type="checkbox" id="garantie" name="garantie" v-model="informations.garantie"
                        @change="updateInfos" class="sr-only peer">
                    <label for="garantie" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                          peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                          flex items-center justify-between">
                        <span>Installation sous garantie</span>
                        <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                    </label>
                </div>

                <div>
                    <input type="checkbox" id="finish" name="finish" v-model="informations.finish" @change="updateInfos"
                        class="sr-only peer">
                    <label for="finish" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                          peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                          flex items-center justify-between">
                        <span>Travaux terminés</span>
                        <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                    </label>
                </div>

                <div>
                    <input type="checkbox" id="need-devis" name="need-devis" v-model="informations.needDevis"
                        @change="updateInfos" class="sr-only peer">
                    <label for="need-devis" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                          peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                          flex items-center justify-between">
                        <span>Devis à réaliser</span>
                        <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                    </label>
                </div>

            </div>
            <!-- ======================= -->

            <label class="label">Travaux effectués</label>
            <textarea class="dossier input" placeholder="Décrivez les travaux effectués ici" name="travaux_effectues"
                v-model="informations.travauxEffectues" @change="updateInfos"></textarea>

            <label class="label">Observations</label>
            <textarea class="dossier input" placeholder="Saisissez vos observations sur l'intervention ici"
                name="observ_intervention" v-model="informations.observations" @change="updateInfos">
        </textarea>

            <div class="img-intervention">
                <input type="file" accept="image/*" ref="inputPhoto" name="intervention-photo" id="intervention-photo"
                    style="display: none;" @change="newPhoto">

                <ul id="preview-photo-intervention">
                    <li v-for="photo in photos">
                        <a v-if="!photo.isUrl" href="javascript: void 0"
                            class="del-photo bg-alert rounded-full h-9 w-9 flex-shrink-0 grid place-items-center mt-4"
                            @click.prevent="deletePhoto(photo.id)">
                            <i class="inline-block h-6 w-6 mask mask-trash bg-white"></i>
                        </a>

                        <div class="photo-container">
                            <img v-if="!photo.loadError"
                                 alt="photo intervention"
                                 :src="photo.data64"
                                 class="h-32"
                                 @error="onPhotoError(photo)">
                            <div v-else class="photo-placeholder">
                                <i class="icon-photo"></i>
                                <span>Photo déjà envoyée</span>
                                <small>Non chargée car pas de réseau</small>
                            </div>
                            <small v-if="photo.isUrl" class="photo-synced-label">Photo déjà synchronisée</small>
                        </div>
                    </li>
                </ul>
            </div>

            <a class="photo btn-secondary mb-5" href="javascript: void 0" @click.prevent="tryAddPhoto">
                Ajouter une photo
            </a>

        </div>

    </div><!-- end .collapsible -->

    <!-- Custom time picker (replaces swal on iOS webview) -->
    <div v-if="showTimePicker"
        class="fixed inset-0 z-50 flex items-center justify-center"
        style="background: rgba(0,0,0,0.5)">
        <div class="bg-white rounded-xl p-6 mx-4 shadow-xl w-full max-w-sm">
            <h3 class="font-semibold text-center mb-4">Temps d'intervention</h3>
            <div class="flex items-center justify-center gap-2">
                <input type="number" class="input text-center" style="width:70px" min="0" max="150"
                    v-model.number="customHours" inputmode="numeric">
                <span class="font-semibold">h</span>
                <input type="number" class="input text-center" style="width:70px" min="0" max="59"
                    v-model.number="customMinutes" inputmode="numeric">
                <span class="font-semibold">min</span>
            </div>
            <div class="flex gap-3 mt-5">
                <button type="button" class="btn-secondary flex-1" @click="cancelTimePicker">Annuler</button>
                <button type="button" class="btn-primary flex-1" @click="confirmTimePicker">Confirmer</button>
            </div>
        </div>
    </div><!-- end time picker -->
    </div><!-- end root -->
</template>


<script>

import moment from 'moment'
import loadImage from 'blueimp-load-image'
import PhotoFiche from '../../../../js/models/PhotoFiche'

export default {

    data() {
        return {
            now: moment().format('HH:mm'),
            photos: [],
            showTimePicker: false,
            customHours: 0,
            customMinutes: 0,
        }
    },

    props: {
        open: null,
        informations: {
            temps_deplacement: null,
            temps_intervention: null,
            heure_arrivee: null,
            heure_depart: null,
            kilometrage: null,
            pieces: null,
            observations: null,
            photo64: null
        },
    },

    methods: {
        setHeureArrivee(event) {
            this.informations.heure_arrivee = event.target.value;
            this.updateInfos()
        },
        setHeureDepart(event) {
            this.informations.heure_depart = event.target.value;
            this.updateInfos()
        },

        updateInfos(change = null) {
            this.$emit('infosChanged', this.informations);
            this.$emit('photosChanged', this.photos);
            if (this.informations.temps_intervention === "Autre" && change === 'temps_intervention') {
                this.customHours = 0;
                this.customMinutes = 0;
                this.showTimePicker = true;
            }
        },

        typeUniqueCheck(type) {
            if (type === 'preventif' && this.informations.preventif === true && this.informations.correctif === true) {
                this.informations.correctif = false
            } else if (type === 'correctif' && this.informations.preventif === true && this.informations.correctif === true) {
                this.informations.preventif = false
            }
            this.updateInfos()
        },

        cancelTimePicker() {
            this.showTimePicker = false;
            this.informations.temps_intervention = null;
        },

        confirmTimePicker() {
            const hours = this.customHours || 0;
            let minutes = this.customMinutes || 0;
            if ((hours === 0 && minutes === 0) || hours < 0 || minutes < 0 || hours > 150 || minutes > 59) {
                swal('Veuillez saisir un temps valide', '', 'warning');
                return;
            }
            if (minutes >= 1 && minutes <= 9) {
                minutes = '0' + minutes;
            }
            const label = hours + 'h' + minutes + 'min';
            let select = document.querySelector('select[name="temps_intervention"]');
            let option = document.createElement('option');
            option.text = label;
            select.add(option);
            this.informations.temps_intervention = label;
            this.$emit('infosChanged', this.informations);
            this.showTimePicker = false;
        },

        tryAddPhoto() {
            if (this.photos.length === 9) {
                swal('9 Photos maximum', '', 'warning')
            } else {
                this.$refs['inputPhoto'].click()
            }
        },

        newPhoto(e) {

            let vueInstance = this;
            let idFi = this.$route.params.id;
            let id = 'P-' + +new Date();

            loadImage(
                e.target.files[0],
                function (img) {

                    let photo = {
                        data64: img.toDataURL(),
                        idFi,
                        id
                    };

                    vueInstance.photos.push(photo);
                    vueInstance.updateInfos();
                    PhotoFiche.addOffline(photo)
                },
                {
                    orientation: true,
                    canvas: true
                } // Options
            );


        },

        deletePhoto(id) {
            this.photos = _.filter(this.photos, p => {
                if (p.id !== id) {
                    return p
                }
            });

            PhotoFiche.remove(id)
        },

        onPhotoError(photo) {
            this.$set(photo, 'loadError', true);
        },

        async fetchPhotos() {
            let idFi = this.$route.params.id;
            let photos = await PhotoFiche.getListForFiche(idFi);
            this.photos = photos.map(function(p) { p.loadError = false; return p; })
        }

    }
    ,

    mounted() {
        if (!this.informations.hasOwnProperty('heure_depart')) {
            this.informations.heure_depart = this.now
        }

        this.fetchPhotos()
    },

    computed: {
        stateClass() {
            if (this.open === 'infos-intervention') {
                return 'open'
            } else {
                return ''
            }
        }
    }

}

</script>

<style scoped>
.photo-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 150px;
    background-color: #f0f0f0;
    border: 2px dashed #ccc;
    border-radius: 5px;
    color: #999;
}

.photo-placeholder i {
    font-size: 3rem;
    margin-bottom: 10px;
}

.photo-placeholder span {
    font-size: 1.4rem;
}

.photo-placeholder small {
    font-size: 1.1rem;
    color: #bbb;
    margin-top: 3px;
}

.photo-synced-label {
    display: block;
    text-align: center;
    color: #999;
    font-size: 1.2rem;
    margin-top: 5px;
}

div.photo-container img {
    max-width: 100%;
    max-height: 600px;
    object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// Infos.vue?ca7e88fa